import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page25() {
  useEffect(() => {
    document.title = "Маяк — Страница 24"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page23" />
        <ForwardLink href="/page25" />
      </div>

      <p style={{ textAlign: "right" }}>24.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Что ты сказал?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я уже сказал--
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Да как ты смеешь возражать мне, пес--
      </p>
      <p>Это выводит МОЛОДОГО из себя:</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Послушайте, я никогда<br/>
        не собирался быть ни домохозяйкой,<br/>
        ни рабом, соглашаясь на эту работу. Это<br/>
        не по правилам! Это жилище более<br/>
        ветхое, чем любой детский лагерь для мальчиков<br/>
        из трущоб, который я когда-либо видел. Экономка<br/>
        самой королевы Англии<br/>
        не смогла бы сделать ничего лучше того,<br/>
        что сделал я, потому что, говорю Вам, я дважды<br/>
        вычистил это место, сэр и--
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        А я говорю, что ты не сделал ничего подобного.
      </p>
      <p style={{ textAlign: "center" }}>
        Я говорю, что ты помоешь еще раз, и помоешь<br/>
        как в этот раз, а потом<br/>
        будешь мыть еще десять раз.<br/>
        И если я скажу тебе<br/>
        поднять и разобрать каждую<br/>
        половицу и доску этого<br/>
        дома и вычистить их голыми,
        окровавленными костяшками, ты<br/>
        это сделаешь. Если я скажу тебе выдернуть<br/>
        каждый ржавый гвоздь из каждой<br/>
        гниющей дырочки и слизать<br/>
        с них ржавчину, пока все эти<br/>
        гвозди не засверкают как хер<br/>
        кашалота, а затем разобрать и собрать всю маячную станцию<br/>
        с нуля, <i>а затем -- сделать<br/>
        все это снова</i> -- ты сделаешь это! И<br/>
        ей-богу, ты сделаешь это<br/>
        с улыбкой, парень, потому что тебе это понравится<br/>
        тоже. И тебе понравится, потому что я<br/>
        говорю, что тебе понравится!
      </p>
      <p style={{ textAlign: "center" }}>
        Еще раз возразишь мне, урежу тебе<br/>
        жалование.
      </p>
      <p style={{ textAlign: "center" }}>Слышишь, парень?</p>
      <p style={{ textAlign: "right" }}>24.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page23" />
        <ForwardLink href="/page25" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710014034/the-lighthouse-script/gimgtm1tnehzhxntqxr4.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page25;
